// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"480":"BirthCenters","527":"RequestForShop","535":"PricingDetails","561":"Dashboard","967":"ShopRequestTimeline"}[chunkId] + "." + {"480":"4d69c1cf","527":"a5e7ab94","535":"9442e9f5","561":"52504fca","967":"8efed4ad"}[chunkId] + ".css";
};